export default __webpack_public_path__ + "static/media/curved-6.ec9818b6.jpg";